import { ClipType, RootState } from 'types';
import './top-posts.scss';
import { useState, useEffect, useCallback } from 'react';
import Card from 'components/app/card';
import moment, { Moment } from 'moment';
import api from 'api';
import { useSelector } from 'react-redux';
import project from 'api/project';

function TopPosts({
    projectId,
    dateFrom,
    dateTo,
    streamIds
} : {
    projectId: number,
    dateFrom: Moment,
    dateTo: Moment,
    streamIds: number[]
}) {
    const [data, setData] = useState<ClipType[]>([]);
    const project = useSelector((state: RootState) => state.project);
    const state = useSelector((state: any) => state.author.active);

    useEffect(()=>{
        getPosts();
    },[state])

    const getPosts = useCallback(async () => {
        const posts = await api.topPosts.getAll(projectId, dateFrom, dateTo, streamIds);
        if (posts.length) {
            setData(posts);
        } else {
            setData([]);
        }
    }, [projectId, dateFrom, dateTo, streamIds])

    useEffect(() => {
        getPosts();
    }, [getPosts])

    return (
        <div className="top-posts">
            <div className="top">
                <p>Top Posts</p>
            </div>
            <div className="body">
                {data.map((x: ClipType, i: number) => (
                    <div className="top-post" key={i}>
                        <Card 
                            clipId={x.ClipId}
                            streamId={x.StreamId}
                            authorName={x.AuthorName}
                            body={x.Body}
                            datePosted={moment(x.DatePosted)}
                            link={x.Link}
                            showComments={project.Id === 4181448}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TopPosts;